import gql from "graphql-tag";

export const ADD_MASTER_CREW_SCHEDULES_PAVING = gql`
  mutation addMasterCrewSchedulesPaving($data: MasterCrewSchedulesInputPaving!) {
    addMasterCrewSchedulesPaving(data: $data)
  }
`;